import React from "react";

import TeamStandingsStatsStore from "@state/stores/offer/statistics/TeamStandingsStatsStore";
import { observer } from "mobx-react";

import { TeamStandingsBody } from "./TeamStandingsBody";

export const TeamStandingsSection = observer(
	function TeamStandingsSection(props: {
		store: TeamStandingsStatsStore;
	}) {
		const teamStandingGroupsData =
			props.store.getCurrentTeamStandingsStatsGroups(
				props.store.activeTab, props.store.teamStandingsTournamentGroup
			);

		const currentTeamStandingsStats =
			props.store.getCurrentTeamStandingsStats(
				props.store.activeTab
			);

		if (!props.store.teamStandingsStats?.data?.teamStanding[0]?.standings) return null;

		return (
			<>
				{!props.store.teamStandingsStats?.isGroupType && (
					<TeamStandingsBody
						store={props.store}
						standings={currentTeamStandingsStats}
						teamStandingsPromotions={
							props.store.extractUniquePromotions(currentTeamStandingsStats) ?? []
						}
					/>
				)}

				{teamStandingGroupsData?.map((teamStandingData) => (
					<TeamStandingsBody
						key={teamStandingData.groupName}
						standings={teamStandingData.standings}
						store={props.store}
						teamStandingsPromotions={
							props.store.extractUniquePromotions(
								teamStandingData.standings
							) ?? []
						}
						groupName={teamStandingData.groupName}
					/>
				))}
			</>
		);
	}
);
